import hamburgerIcon from "@assets/header/menu/hamburgerIconNew.svg";
import hamburgerIconBlue from "@assets/header/newIcons/hamburger.svg";
import styles from "@components/Modules/HeaderNew/Header.module.css";
import cx from "classnames";
import { ReactElement } from "react";

export type MobileMenuIconProps = {
  showMenuIcon: boolean;
  onClick: () => void;
  variant?: "blue" | "white";
};

export function MobileMenuIcon({
  showMenuIcon,
  onClick,
  variant = "white",
}: MobileMenuIconProps): ReactElement {
  const Icon = variant === "blue" ? hamburgerIconBlue : hamburgerIcon;
  return (
    <>
      {showMenuIcon ? (
        <button className={cx(styles.hamburgerIcon)} onClick={onClick}>
          <img className={cx(styles.iconMenu)} src={Icon} alt="menu" />
        </button>
      ) : null}
    </>
  );
}
